(function () {
  if (window.DastkaarReviewsSlider) {
    window.DastkaarReviewsSlider.init(document);
    return;
  }

  function init(scope) {
    const roots = [];
    if (scope && scope.matches && scope.matches('[data-dastkaar-reviews-slider]')) roots.push(scope);
    if (scope && scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-dastkaar-reviews-slider]'));

    roots.forEach(function (root) {
      if (root.dataset.dastkaarReviewsInitialized === 'true') return;
      const viewport = root.querySelector('.dastkaar-reviews__viewport');
      const track = root.querySelector('.dastkaar-reviews__track');
      const groups = track ? track.querySelectorAll('.dastkaar-reviews__group') : [];
      if (!viewport || !track || !groups.length) return;

      root.dataset.dastkaarReviewsInitialized = 'true';
      const firstGroup = groups[0];
      const duration = Math.max(18, Number(root.dataset.scrollDuration) || 36);
      const wantsAuto = root.dataset.autoScroll === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let cycleWidth = firstGroup.getBoundingClientRect().width;
      let lastFrame = 0;
      let dragging = false;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let moved = false;
      let interactionUntil = 0;
      let pointerId = null;
      let rafId = 0;
      const now = function () { return window.performance && performance.now ? performance.now() : Date.now(); };

      const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(function () {
        cycleWidth = firstGroup.getBoundingClientRect().width;
      }) : null;
      if (resizeObserver) resizeObserver.observe(firstGroup);

      function pauseAfterInteraction(delay) {
        interactionUntil = now() + (Number(delay) || 1200);
      }
      function animate(timestamp) {
        if (!root.isConnected) {
          if (resizeObserver) resizeObserver.disconnect();
          return;
        }
        if (!lastFrame) lastFrame = timestamp;
        const elapsed = Math.min(50, timestamp - lastFrame);
        lastFrame = timestamp;
        if (wantsAuto && !dragging && timestamp > interactionUntil && cycleWidth > viewport.clientWidth + 1) {
          viewport.scrollLeft += (cycleWidth / duration) * (elapsed / 1000);
          if (viewport.scrollLeft >= cycleWidth) viewport.scrollLeft -= cycleWidth;
        }
        rafId = window.requestAnimationFrame(animate);
      }

      viewport.addEventListener('pointerdown', function (event) {
        pauseAfterInteraction(1000);
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        moved = false;
        pointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) viewport.setPointerCapture(pointerId);
      });
      viewport.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') {
          pauseAfterInteraction(900);
          return;
        }
        if (!dragging || event.pointerId !== pointerId) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 3) {
          moved = true;
          event.preventDefault();
          viewport.scrollLeft = dragStartScroll - delta;
        }
      });
      function endDrag(event) {
        if (dragging && (!event || event.pointerId === pointerId)) {
          dragging = false;
          pointerId = null;
          viewport.classList.remove('is-dragging');
          pauseAfterInteraction(900);
        }
      }
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('wheel', function () { pauseAfterInteraction(1000); }, { passive: true });
      viewport.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) pauseAfterInteraction(1200);
      });
      viewport.addEventListener('click', function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, true);
      rafId = window.requestAnimationFrame(animate);
      root.addEventListener('shopify:section:unload', function () {
        if (resizeObserver) resizeObserver.disconnect();
        if (rafId) window.cancelAnimationFrame(rafId);
      });
    });
  }

  window.DastkaarReviewsSlider = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();